
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1VYG6", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $gWF6I = parcelRequire("gWF6I");


var $1o4fX = parcelRequire("1o4fX");


var $euL71 = parcelRequire("euL71");


var $ivb8S = parcelRequire("ivb8S");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $irVI7 = parcelRequire("irVI7");


var $a1uvs = parcelRequire("a1uvs");

var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $bFDX4 = parcelRequire("bFDX4");


var $9wGTI = parcelRequire("9wGTI");


var $6eN5W = parcelRequire("6eN5W");


var $iuUMQ = parcelRequire("iuUMQ");


var $gqp7m = parcelRequire("gqp7m");


var $cFEpk = parcelRequire("cFEpk");


var $922yL = parcelRequire("922yL");


var $8C5kA = parcelRequire("8C5kA");

const $0b082f0088987b79$var$GRACE_PERIOD = 14; // days after trial ends for both HAMS and CCP
const $0b082f0088987b79$export$ede2048f0629c2b6 = (queryData)=>{
    const intl = (0, $8C5kA.default)();
    const trialEndDateString = queryData?.license?.trialEndDate;
    // When the customer starts an instance, the exact timestamp of the trial end is not
    // recorded. We made the decision to always return the UTC date for `trialEndDate`.
    // We return the localized dates for display purpose
    const trialEndDate = trialEndDateString ? new Date(trialEndDateString) : null;
    if (!trialEndDate || !(0, $cFEpk.default)(new Date(trialEndDate))) return null;
    const trialEndDateLong = intl.formatDate(trialEndDate, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const trialEndDateShort = intl.formatDate(trialEndDate, {
        month: 'long',
        day: 'numeric',
        formatMatcher: 'best fit'
    });
    const deactivationDate = intl.formatDate((0, $922yL.default)(trialEndDate, $0b082f0088987b79$var$GRACE_PERIOD), {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const deactivationDateShort = intl.formatDate((0, $922yL.default)(trialEndDate, $0b082f0088987b79$var$GRACE_PERIOD), {
        month: 'long',
        day: 'numeric',
        formatMatcher: 'best fit'
    });
    return {
        deactivationDate: deactivationDate,
        trialEndDateShort: trialEndDateShort,
        trialEndDateLong: trialEndDateLong,
        deactivationDateShort: deactivationDateShort
    };
};



var $8JJsY = parcelRequire("8JJsY");


var $53KZp = parcelRequire("53KZp");


var $7XaXR = parcelRequire("7XaXR");


var $hY10E = parcelRequire("hY10E");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $298fe7d1fa52d113$export$2c393978d59015b8 = /*#__PURE__*/ function(BillingSourceSystem) {
    BillingSourceSystem["CCP"] = "CCP";
    BillingSourceSystem["HAMS"] = "HAMS";
    return BillingSourceSystem;
}({});



var $5lbXZ = parcelRequire("5lbXZ");


var $iTy4g = parcelRequire("iTy4g");

/* TrialFlagsComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $4LS1B = parcelRequire("4LS1B");





var $gqqjz = parcelRequire("gqqjz");





var $dWCFT = parcelRequire("dWCFT");

var $bJbIe = parcelRequire("bJbIe");

const $00cf1178d49e1612$var$getOrdinalSuffix = (day)=>{
    if (day >= 11 && day <= 13) return 'th';
    switch(day % 10){
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
const $00cf1178d49e1612$export$6f4585a15293d378 = (dateString)=>{
    const date = (0, $bJbIe.default)(dateString, 'MMMM d, yyyy', new Date());
    const month = (0, $dWCFT.default)(date, 'MMMM');
    const day = (0, $dWCFT.default)(date, 'd');
    const dayNumber = parseInt(day, 10);
    const ordinalSuffix = $00cf1178d49e1612$var$getOrdinalSuffix(dayNumber);
    return `${month} ${day}${ordinalSuffix}`;
};



var $cN2XO = parcelRequire("cN2XO");




const $23ca7e64a5767c43$var$FREE_USER_LIMIT = 10;
const $23ca7e64a5767c43$var$linkStyles = {
    modalTakeAction: "_syaz13af _1bnx8stv _d0altlke"
};
const $23ca7e64a5767c43$var$i18n = (0, $cgtv4.defineMessages)({
    titlePremium: {
        id: "trial-components.flag.title.premium",
        defaultMessage: "Your Premium trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    titleStandard: {
        id: "trial-components.flag.title.standard",
        defaultMessage: "Your Standard trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    removeUsersLinkText: {
        id: "trial-components.flag.remove-users.link-text",
        defaultMessage: "Remove users"
    },
    choosePlanLinkText: {
        id: "trial-components.flag.choose-plan.link-text",
        defaultMessage: "Choose plan"
    },
    infoDescription: {
        id: "trial-components.flag.info.description",
        defaultMessage: "Add payment details to stay on {edition} and keep the features you love. Otherwise, your site will be downgraded to Confluence Free."
    },
    warningDescription: {
        id: "trial-components.flag.warning.description",
        defaultMessage: "Add payment details to stay on {edition} and keep more than 10 users, or remove users and switch to Confluence Free. <strong>If you don\u2019t take action, your site will be deactivated on {deactivationDateLong}.</strong>"
    },
    addPaymentDetailsCTA: {
        id: "trial-components.flag.add-payment-details",
        defaultMessage: "Add payment details"
    },
    reverseTrialsTitleOverUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-title.overUserLimit.three-days-left",
        defaultMessage: "Choose a plan to avoid deactivation"
    },
    reverseTrialsTitleOverUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-title.overUserLimit.one-day-left",
        defaultMessage: "Choose a plan to avoid deactivation"
    },
    reverseTrialsTitleUnderUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-title.underUserLimit.three-days-left",
        defaultMessage: "Final stretch! Your trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    reverseTrialsTitleUnderUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-title.underUserLimit.one-day-left",
        defaultMessage: "Time\u2019s almost up! Your trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    reverseTrialsDescriptionOverUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-description.overUserLimit.three-days-left",
        defaultMessage: "You have more than {freeUserLimit} users, so you\u2019ll need to choose a paid plan or remove users by {deactivationDateLong}."
    },
    reverseTrialsDescriptionOverUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-description.overUserLimit.one-day-left",
        defaultMessage: "You have more than {freeUserLimit} users, so you\u2019ll need to choose a paid plan or remove users by {deactivationDateLong}."
    },
    reverseTrialsDescriptionUnderUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-description.underUserLimit.three-days-left",
        defaultMessage: "See pricing and choose a plan, or you\u2019ll be downgraded to a free plan with limited features."
    },
    reverseTrialsDescriptionUnderUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-description.underUserLimit.one-day-left",
        defaultMessage: "See pricing and choose a plan, or you\u2019ll be downgraded to a free plan with limited features."
    },
    autoUpgradeTitleLastDayOfPredunning: {
        id: "trial-components.flag.auto-upgrade.title-last-day-of-predunning",
        defaultMessage: "Take action, avoid deactivation"
    },
    autoUpgradeTitleWithDaysLeft: {
        id: "trial-components.flag.auto-upgrade.title-with-days-left",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{trialDaysLeft, plural, =1 {# day} other {# days}} left to avoid deactivation"
    },
    autoUpgradeDescription: {
        id: "trial-components.flag.auto-upgrade.description",
        defaultMessage: "Add payment or remove users by {deactivationDate} to avoid site deactivation."
    },
    takeActionCTA: {
        id: "trial-components.flag.auto-upgrade.take-action",
        defaultMessage: "Take action"
    }
});
const $23ca7e64a5767c43$var$LINK_TO_REMOVE_USERS = 'https://support.atlassian.com/confluence-cloud/docs/removing-users-and-downgrading-to-confluence-free/';
const $23ca7e64a5767c43$var$USER_ACTION_REMOVE_USER = 'removeUser';
const $23ca7e64a5767c43$var$USER_ACTION_ADD_BILLING = 'addBilling';
const $23ca7e64a5767c43$var$USER_ACTION_CHOOSE_PLAN = 'choosePlan';
const $23ca7e64a5767c43$var$USER_ACTION_OPEN_AUTO_UPGRADE_DEACTIVATION_MODAL = 'openAutoUpgradeDeactivationModal';
const $23ca7e64a5767c43$var$getActionAnalyticsEvent = (edition, type, userAction, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'trialActionComponent',
            attributes: {
                edition: edition,
                trialDaysLeft: trialDaysLeft,
                daysLeftInPredunning: daysLeftInPredunning,
                userAction: userAction,
                type: type,
                premiumReverseTrialABCohort: premiumReverseTrialABCohort,
                autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
            },
            source: 'trialFlag'
        }
    });
const $23ca7e64a5767c43$var$TrialFlagsComponentInner = ({ daysLeftInPredunning: daysLeftInPredunning, deactivationDateLong: deactivationDateLong, edition: edition, flags: flags, licenseConsumingUserCount: licenseConsumingUserCount, linkToAddBilling: linkToAddBilling, cloudId: cloudId, onDismiss: onDismissStoreFlagOnboardingState, trialDaysLeft: trialDaysLeft, isEligibleForPremiumReverseTrialsExperiment: isEligibleForPremiumReverseTrialsExperiment, planSelectionPageUrl: planSelectionPageUrl, autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { orgId: orgId, environment: environment } = (0, $bQm3c.useSessionData)();
    const isWarn = licenseConsumingUserCount > 10;
    const type = isWarn ? 'warning' : 'info';
    let flagId = `${edition}-trial-${trialDaysLeft}-day-${type}-flag`;
    const premiumReverseTrialABCohort = (0, $7XaXR.usePremiumReverseTrialABCohort)({
        isEligible: isEligibleForPremiumReverseTrialsExperiment,
        touchpointId: 'trial-flag',
        attributes: {
            planSelectionPageUrl: planSelectionPageUrl,
            trialDaysLeft: trialDaysLeft,
            deactivationDate: deactivationDateLong,
            licenseConsumingUserCount: licenseConsumingUserCount
        }
    });
    const hasShownFlagRef = (0, $42omo.useRef)(false);
    const flagIdRef = (0, $42omo.useRef)(null);
    const hasFiredAnalyticsRef = (0, $42omo.useRef)(false);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        flagIdRef.current && flags.hideFlag(flagIdRef.current);
        onDismissStoreFlagOnboardingState();
    }, [
        flags,
        onDismissStoreFlagOnboardingState
    ]);
    const handleAddBillingClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_ADD_BILLING, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const handleRemoveUsersClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_REMOVE_USER, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const handleChoosePlanClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_CHOOSE_PLAN, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const handleTakeActionClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_OPEN_AUTO_UPGRADE_DEACTIVATION_MODAL, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const addPaymentDetails = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.addPaymentDetailsCTA),
        href: linkToAddBilling,
        target: '_blank',
        onClick: handleAddBillingClick
    };
    const removeUsersAction = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.removeUsersLinkText),
        href: $23ca7e64a5767c43$var$LINK_TO_REMOVE_USERS,
        target: '_blank',
        onClick: handleRemoveUsersClick
    };
    const removeUsersNavigateToOrgInAdminHub = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.removeUsersLinkText),
        href: (0, $cN2XO.linkToAdminHubOrg)(environment, orgId, '/users?status=ACTIVE'),
        target: '_blank',
        onClick: handleRemoveUsersClick
    };
    const choosePlanLink = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.choosePlanLinkText),
        href: planSelectionPageUrl,
        target: '_blank',
        onClick: handleChoosePlanClick
    };
    const autoUpgradeTakeActionContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4LS1B.AutoUpgradeAvoidDeactivationModal), {
        product: "confluence",
        touchpointId: "avoid-deactivation-flag",
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $23ca7e64a5767c43$var$linkStyles.modalTakeAction,
        testId: "auto-upgrade-avoid-deactivation-flag-take-action-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.takeActionCTA)));
    const autoUpgradeTakeAction = {
        content: autoUpgradeTakeActionContent,
        onClick: handleTakeActionClick
    };
    const editionKey = edition === (0, $euL71.ConfluenceEdition).STANDARD ? 'Standard' : 'Premium';
    let flag = null;
    if (premiumReverseTrialABCohort === 'variation' && deactivationDateLong !== undefined) {
        const userLimitDescriptor = licenseConsumingUserCount > $23ca7e64a5767c43$var$FREE_USER_LIMIT ? 'Over' : 'Under';
        const rtTitle = `reverseTrialsTitle${userLimitDescriptor}UserLimit${trialDaysLeft}DaysLeft`;
        const rtDescription = `reverseTrialsDescription${userLimitDescriptor}UserLimit${trialDaysLeft}DaysLeft`;
        flagId = `${flagId}-reverse-trial`;
        flag = {
            id: flagId,
            type: type,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$23ca7e64a5767c43$var$i18n[rtTitle],
                values: {
                    trialDaysLeft: trialDaysLeft
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$23ca7e64a5767c43$var$i18n[rtDescription],
                values: isWarn ? {
                    deactivationDateLong: (0, $00cf1178d49e1612$export$6f4585a15293d378)(deactivationDateLong),
                    freeUserLimit: $23ca7e64a5767c43$var$FREE_USER_LIMIT
                } : {}
            }),
            actions: isWarn ? [
                choosePlanLink,
                removeUsersNavigateToOrgInAdminHub
            ] : [
                choosePlanLink
            ],
            onClose: onDismiss
        };
    } else if (autoUpgradeNotATrialExperimentCohort === 'treatment' && deactivationDateLong !== undefined && daysLeftInPredunning !== undefined) {
        const title = daysLeftInPredunning === 0 ? $23ca7e64a5767c43$var$i18n.autoUpgradeTitleLastDayOfPredunning : $23ca7e64a5767c43$var$i18n.autoUpgradeTitleWithDaysLeft;
        flag = {
            id: flagId,
            type: 'warning',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...title,
                values: {
                    trialDaysLeft: daysLeftInPredunning
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$23ca7e64a5767c43$var$i18n.autoUpgradeDescription,
                values: {
                    deactivationDate: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        weight: "bold"
                    }, (0, $00cf1178d49e1612$export$6f4585a15293d378)(deactivationDateLong))
                }
            }),
            actions: [
                autoUpgradeTakeAction
            ],
            onClose: onDismiss
        };
    } else if (premiumReverseTrialABCohort !== undefined) flag = {
        id: flagId,
        type: type,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$23ca7e64a5767c43$var$i18n[`title${editionKey}`],
            values: {
                trialDaysLeft: trialDaysLeft
            }
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$23ca7e64a5767c43$var$i18n[`${type}Description`],
            values: isWarn ? {
                deactivationDateLong: deactivationDateLong,
                strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        as: "strong"
                    }, chunks),
                edition: editionKey
            } : {
                edition: editionKey
            }
        }),
        actions: isWarn ? [
            addPaymentDetails,
            removeUsersAction
        ] : [
            addPaymentDetails
        ],
        onClose: onDismiss
    };
    flagIdRef.current = flagId;
    if (hasShownFlagRef && !hasShownFlagRef.current && flag) {
        flags.showFlag(flag).then((newFlag)=>{
            // If a new flag was created, store the new flag's ID so we can update it.  Note that
            // `showFlag()` only asynchronously returns a valid newFlag if it created a new flag;
            // if it found an existing flag with the specified ID then it asynchronously returns
            // nothing (undefined).
            if (newFlag) flagIdRef.current = newFlag.id;
        });
        hasShownFlagRef.current = true;
    }
    if (!hasFiredAnalyticsRef.current && flag) {
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'trialFlagScreen',
                attributes: {
                    edition: edition,
                    trialDaysLeft: trialDaysLeft,
                    daysLeftInPredunning: daysLeftInPredunning,
                    type: type,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort,
                    autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
                }
            }
        }).fire(); // Mark the event as fired
        hasFiredAnalyticsRef.current = true;
    }
    return null;
};
const $23ca7e64a5767c43$export$a104e87722fbc3f2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23ca7e64a5767c43$var$TrialFlagsComponentInner, {
            flags: flags,
            ...props
        });
    });
};


const $b12f361e855fedcd$var$DAYS_LEFT_IN_TRIAL_TO_SHOW_FLAGS = [
    1,
    3
];
const $b12f361e855fedcd$var$DAYS_LEFT_IN_PRE_DUNNING_TO_SHOW_FLAGS_AUTO_UPGRADE_NOT_A_TRIAL_EXPERIMENT = [
    3,
    2,
    1,
    -0
];
const $b12f361e855fedcd$var$mapDismissStateKeyInTrial = (daysLeft)=>daysLeft ? `dismissedTrial${daysLeft}DayFlag` : '';
const $b12f361e855fedcd$var$mapDismissStateKeyInPredunning = (daysLeft)=>daysLeft ? `dismissedPredunning${daysLeft}DayFlag` : '';
const $b12f361e855fedcd$export$c108f21945b8b79 = ()=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn, userId: userId, edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const hasExperienceTrackerStartedRef = (0, $42omo.useRef)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isTrialEdition = edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const skipTrialDetailsQuery = !isLicensed || !isLoggedIn || !isSiteAdmin || !userId || !isTrialEdition;
    const { data: trialDetailsData, loading: trialLoading, error: trialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query TrialFlagsTrialDetailsQuery{license{billingSourceSystem licenseConsumingUserCount trialEndDate}}`, {
        skip: skipTrialDetailsQuery
    });
    const licenseConsumingUserCount = (0, $iuUMQ.getLicenseConsumingUserCountFromQuery)(trialDetailsData);
    const billingSourceSystem = trialDetailsData?.license?.billingSourceSystem;
    const trialEndDate = trialDetailsData?.license?.trialEndDate;
    const formattedDate = (0, $0b082f0088987b79$export$ede2048f0629c2b6)(trialDetailsData);
    const deactivationDateLong = formattedDate?.deactivationDate;
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialEndDate) ?? null;
    const isInTrial = !!trialEndDate && trialDaysLeft && trialDaysLeft >= 0;
    const skipPredunningQuery = skipTrialDetailsQuery || isInTrial || billingSourceSystem !== (0, $298fe7d1fa52d113$export$2c393978d59015b8).CCP;
    const { deactivationDate: deactivationDate, isPreDunningPeriod: isPreDunningPeriod, errorSource: predunningErrorSource, loading: predunningLoading, error: predunningError } = (0, $iTy4g.useIsPreDunningPeriod)({
        skip: skipPredunningQuery
    });
    const { daysLeftUntilDeactivation: daysLeftUntilDeactivation, dateString: deactivationDateString } = deactivationDate || {};
    const isInTrialOrPredunning = isInTrial || isPreDunningPeriod;
    const isValidTrialDayToShowFlag = !!trialDaysLeft && $b12f361e855fedcd$var$DAYS_LEFT_IN_TRIAL_TO_SHOW_FLAGS.includes(trialDaysLeft);
    const isValidPredunningDayToShowFlag = isPreDunningPeriod && daysLeftUntilDeactivation !== undefined && $b12f361e855fedcd$var$DAYS_LEFT_IN_PRE_DUNNING_TO_SHOW_FLAGS_AUTO_UPGRADE_NOT_A_TRIAL_EXPERIMENT.includes(daysLeftUntilDeactivation) && (0, $9wGTI.fg)('auto_upgrade_not_a_trial_experiment_connie_gate');
    const dismissedFlagKey = isPreDunningPeriod ? $b12f361e855fedcd$var$mapDismissStateKeyInPredunning(daysLeftUntilDeactivation) : $b12f361e855fedcd$var$mapDismissStateKeyInTrial(trialDaysLeft);
    let onboardingFlagKey;
    if (trialDaysLeft === 1) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).TRIAL_1_DAY_FLAG_DISMISSED;
    else if (trialDaysLeft === 3) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).TRIAL_3_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 3) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_3_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 2) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_2_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 1) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_1_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 0) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_0_DAY_FLAG_DISMISSED;
    else // This shouldn't actually get used since the query will be skipped and the
    // component will return null. We just need to make sure we're passing a valid
    // key to the `useGetOnboardingState` hook.
    onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).TRIAL_UNHANDLED_DAY_FLAG_DISMISSED;
    const skipCommerceQueries = !(isValidTrialDayToShowFlag || isValidPredunningDayToShowFlag);
    const { hasBillingInformation: hasBillingInformation, loading: billingLoading, error: billingErr } = (0, $gqp7m.useHasBillingInformation)(skipCommerceQueries);
    const skipGetOnboardingStateQuery = skipCommerceQueries || hasBillingInformation;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateErr } = (0, $ivb8S.useGetOnboardingState)(onboardingFlagKey, skipGetOnboardingStateQuery);
    const data = (0, $ivb8S.deserializeState)(onboardingStateData);
    const hasDismissedFlag = data[dismissedFlagKey];
    const { loading: useAutoUpgradeNotATrialExperimentLoading, error: useAutoUpgradeNotATrialExperimentError, autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort } = (0, $5lbXZ.useAutoUpgradeNotATrialExperiment)({
        isSiteAdmin: isSiteAdmin,
        edition: edition,
        hasBillingInformation: hasBillingInformation,
        commerceBackendName: billingSourceSystem,
        isInTrialOrPredunning: isInTrialOrPredunning,
        source: 'confluence_trial_flag',
        analyticAttributes: {
            trialDaysLeft: trialDaysLeft
        },
        skip: !(0, $9wGTI.fg)('auto_upgrade_not_a_trial_experiment_connie_gate') || !(isValidPredunningDayToShowFlag || isValidTrialDayToShowFlag)
    });
    const shouldSkipPremiumReverseTrialsCheck = skipCommerceQueries || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || hasBillingInformation || !(0, $9wGTI.fg)('growth_confluence_buy_reverse_trials_fg');
    const { isReverseTrialer: isReverseTrialer, loading: isReverseTrialLoading, error: isReverseTrialerError } = (0, $hY10E.useReverseTrialCohort)({
        skip: shouldSkipPremiumReverseTrialsCheck
    });
    const { isAvailableToUser: isPlanSelectionPageUrlAvailable, planSelectionPageUrl: planSelectionPageUrl, error: pspUrlError, loading: isPSPUrlLoading } = (0, $53KZp.usePlanSelectionPageInfo)({
        skip: shouldSkipPremiumReverseTrialsCheck
    });
    const isEligibleForPremiumReverseTrialsExperiment = (0, $7XaXR.useIsEligibleForPremiumReverseTrialsExperiment)({
        isReverseTrialer: isReverseTrialer,
        isInTrial: (trialDaysLeft ?? 0) > 0,
        edition: edition,
        hasBillingInformation: hasBillingInformation,
        commerceBackendName: billingSourceSystem,
        isPlanSelectionPageUrlAvailable: isPlanSelectionPageUrlAvailable
    });
    const { paymentFlowUrl: paymentFlowUrl, loading: urlLoading, error: urlErr } = (0, $8JJsY.useBillingUrls)(skipCommerceQueries || autoUpgradeNotATrialExperimentCohort === 'treatment');
    const onDismissFlag = (0, $42omo.useCallback)(()=>{
        if (!hasDismissedFlag) setOnboardingState({
            key: onboardingFlagKey,
            value: 'true'
        });
    }, [
        onboardingFlagKey,
        hasDismissedFlag,
        setOnboardingState
    ]);
    const canTrackExperience = !skipTrialDetailsQuery && !skipCommerceQueries && !skipGetOnboardingStateQuery;
    if (!hasExperienceTrackerStartedRef.current && canTrackExperience) {
        experienceTracker.start({
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE)
        });
        hasExperienceTrackerStartedRef.current = true;
    }
    const loading = trialLoading || urlLoading || billingLoading || onboardingStateLoading || isReverseTrialLoading || isPSPUrlLoading || useAutoUpgradeNotATrialExperimentLoading || predunningLoading;
    // `TrialDetailsQuery` can throw Permission exception if initiater doesn't have sufficient permission
    // Permission error in this case is expected and FE should handle it gracefully - "markErrorAsHandled" and abort the experience instead of reporting as failures.
    if (trialError && (0, $1uFM6.isUnauthorizedError)(trialError)) {
        (0, $7Sm4c.markErrorAsHandled)(trialError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uvs.ExperienceAbort), {
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
            reason: "Aborted due to insufficient permission"
        });
    }
    // `useHasBillingInformation` can cause a rate limiting error
    if (billingErr && (0, $bFDX4.isTooManyRequestsError)(billingErr)) {
        (0, $7Sm4c.markErrorAsHandled)(billingErr);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uvs.ExperienceAbort), {
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
            reason: "Aborted due to rate limit exceeded error"
        });
    }
    const error = trialError || urlErr || billingErr || onboardingStateErr || pspUrlError || isReverseTrialerError || useAutoUpgradeNotATrialExperimentError || predunningError;
    const shouldShowFlag = autoUpgradeNotATrialExperimentCohort === 'treatment' ? isValidPredunningDayToShowFlag : isValidTrialDayToShowFlag;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
        error: error,
        attributes: {
            trialErr: trialError?.message,
            urlErr: urlErr?.message,
            billingErr: billingErr?.message,
            onboardingStateErr: onboardingStateErr?.message,
            pspUrlError: pspUrlError?.message,
            isReverseTrialerError: isReverseTrialerError?.message,
            useAutoUpgradeNotATrialExperimentError: useAutoUpgradeNotATrialExperimentError?.message,
            predunningError: predunningError?.message,
            predunningErrorSource: predunningErrorSource
        }
    });
    if (loading) return null;
    if (skipGetOnboardingStateQuery || !onboardingStateData || !shouldShowFlag || hasDismissedFlag || !isTrialEdition) {
        experienceTracker.abort({
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
            reason: 'Aborted because a pre-requisite was not met'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23ca7e64a5767c43$export$a104e87722fbc3f2), {
        edition: edition,
        daysLeftInPredunning: daysLeftUntilDeactivation,
        deactivationDateLong: deactivationDateLong || deactivationDateString,
        licenseConsumingUserCount: licenseConsumingUserCount,
        linkToAddBilling: paymentFlowUrl,
        trialDaysLeft: trialDaysLeft,
        cloudId: cloudId,
        onDismiss: onDismissFlag,
        isEligibleForPremiumReverseTrialsExperiment: isEligibleForPremiumReverseTrialsExperiment,
        planSelectionPageUrl: planSelectionPageUrl,
        autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
        attributes: {
            autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort,
            daysLeftUntilDeactivation: daysLeftUntilDeactivation,
            trialDaysLeft: trialDaysLeft
        }
    }));
};
module.exports["TrialFlags"] = $b12f361e855fedcd$export$c108f21945b8b79;

});

parcelRegister("a1uvs", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $5da8a4a03d184e93$export$c9b6bcd70239a39c = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceAbort(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, reason: reason } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== experienceTracker || $[1] !== name || $[2] !== reason) {
        t1 = ()=>experienceTracker.abort({
                name: name,
                reason: reason
            });
        t2 = [
            name,
            reason,
            experienceTracker
        ];
        $[0] = experienceTracker;
        $[1] = name;
        $[2] = reason;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceAbort({ name: name, reason: reason }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>experienceTracker.abort({
            name: name,
            reason: reason
        }), [
        name,
        reason,
        experienceTracker
    ]);
    return null;
};
module.exports["ExperienceAbort"] = $5da8a4a03d184e93$export$c9b6bcd70239a39c;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("gqp7m", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $bFDX4 = parcelRequire("bFDX4");

const $211f773a291d5685$export$b4b101074ba9b8a2 = (skip = false)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const shouldSkip = skip || !isSiteAdmin || !cloudId;
    const { data: data, loading: loading, error: queryError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useHasBillingInformationIsAccountInvoiceableQuery($cloudId:ID!$hamsProductKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$hamsProductKey){...on CommerceEntitlementInfoCcp{entitlementId entitlement{...on CcpEntitlement{id subscription{...on CcpSubscription{id accountDetails{invoiceGroup{invoiceable id}}}}}}}}}}`, {
        variables: {
            cloudId: cloudId,
            hamsProductKey: 'confluence.ondemand'
        },
        skip: shouldSkip,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (shouldSkip) return {
        hasBillingInformation: false,
        loading: false,
        error: null
    };
    let hasBillingInformation = false;
    let error = queryError || null;
    if (!loading) {
        if (queryError) // unauthorized, not found, too many requests errors are expected
        {
            if ((0, $1uFM6.isUnauthorizedError)(queryError) || (0, $f9jv7.isNotFoundError)(queryError) || (0, $bFDX4.isTooManyRequestsError)(queryError) || $211f773a291d5685$var$isGraphQLTooManyRequestsError(queryError)) {
                (0, $7Sm4c.markErrorAsHandled)(queryError);
                error = null;
            }
        } else hasBillingInformation = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable ?? false;
    }
    return {
        hasBillingInformation: hasBillingInformation,
        loading: loading,
        error: error
    };
};
/**
 * Checks if the provided error is a GraphQL error indicating a "429 Too Many Requests" scenario.
 *
 * In GraphQL, it's common for the HTTP response status to be 200 OK even when there are
 * application-level errors. This function helps identify "Too Many Requests" errors that
 * might be returned from a downstream service but are wrapped in a GraphQL response.
 *
 * @param error - The error object to inspect. It could be an ApolloErrorInterop or a generic error.
 * @returns {boolean} - Returns true if the error message contains an indication of a "429 Too Many Requests" error.
 */ const $211f773a291d5685$var$isGraphQLTooManyRequestsError = (error)=>{
    if (error && error.message) return error.message.includes('GraphQL error: [429 Too Many Requests]');
    return false;
};
module.exports["useHasBillingInformation"] = $211f773a291d5685$export$b4b101074ba9b8a2;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("hY10E", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $917iu = parcelRequire("917iu");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $kAcNG = parcelRequire("kAcNG");


var $a119A = parcelRequire("a119A");

const $8853af7e8236bde8$export$4695bad538a258b4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    // SignUpProperties that are sent from BXP
    const { isReverseTrialer: isReverseTrialer, loading: loading, error: error } = $8853af7e8236bde8$export$153e1a2894ed595({
        skip: !isSiteAdmin || !isPremium
    });
    // Master FF to quickly enable / disable all Onboarding Experiences
    const isReverseTrialEligibleUser = isSiteAdmin && isPremium && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isReverseTrialTreatmentCohort = !loading && !error && isReverseTrialer;
    return {
        isReverseTrialEligible: isReverseTrialEligibleUser && isReverseTrialTreatmentCohort
    };
};
function $8853af7e8236bde8$export$153e1a2894ed595({ skip: skip } = {}) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: reverseTrialData, loading: isReverseTrialLoading, error: reverseTrialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`, {
        skip: skip
    });
    const { loading: isSitePersonalizationLoading, error: sitePersonalizationError, attributes: attributes } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skip
    });
    const TRIAL_PERIOD_DAYS = 45;
    let isWithinFirstTrialPeriod = true; // Default to true because if the activation date is not available, this means that the site was recently provisioned
    const activationDateAttr = attributes?.find((attr)=>attr.name === 'confluence.ondemand.activationDate');
    if (activationDateAttr && activationDateAttr.value) {
        const activationDate = new Date(activationDateAttr.value);
        const daysSinceActivation = (0, $917iu.default)(new Date(), activationDate);
        isWithinFirstTrialPeriod = daysSinceActivation <= TRIAL_PERIOD_DAYS;
    }
    const reverseTrialCohort = reverseTrialData?.signUpProperties?.reverseTrial;
    return {
        isReverseTrialer: isWithinFirstTrialPeriod && reverseTrialCohort === (0, $a119A.ReverseTrialCohort).ENROLLED,
        reverseTrialCohort: reverseTrialCohort,
        loading: skip ? false : isReverseTrialLoading || isSitePersonalizationLoading,
        error: skip ? null : reverseTrialError || sitePersonalizationError
    };
}
module.exports["useReverseTrialCohort"] = $8853af7e8236bde8$export$153e1a2894ed595;

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("a119A", function(module, exports) {
/**
 * @generated SignedSource<<7c96ffe5db93bb7b8bc74d6411281d3b>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $15e6aec9d603aba5$export$8798225e6f84b893 = /*#__PURE__*/ function(ReverseTrialCohort) {
    ReverseTrialCohort["CONTROL"] = "CONTROL";
    ReverseTrialCohort["ENROLLED"] = "ENROLLED";
    ReverseTrialCohort["NOT_ENROLLED"] = "NOT_ENROLLED";
    ReverseTrialCohort["UNASSIGNED"] = "UNASSIGNED";
    ReverseTrialCohort["UNKNOWN"] = "UNKNOWN";
    ReverseTrialCohort["VARIANT"] = "VARIANT";
    return ReverseTrialCohort;
}({});
module.exports["ReverseTrialCohort"] = $15e6aec9d603aba5$export$8798225e6f84b893;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("dhYWb", function(module, exports) {
const $9336b0b8d90394bf$export$7af15fb4b1ef8bf2 = 'auto_upgrade_not_a_trial';
const $9336b0b8d90394bf$export$31c76e063a58551f = 14;
const $9336b0b8d90394bf$export$e25ee5e8d56c9434 = 'auto-upgrade-avoid-deactivation-modal';
const $9336b0b8d90394bf$export$4c68c8f979e7c34e = 'autoUpgradeAvoidDeactivationModal';
const $9336b0b8d90394bf$export$e1dd560345bb2391 = 'autoUpgradeAvoidDeactivationBanner';
const $9336b0b8d90394bf$export$fb4037ac52e8f2af = 'auto-upgrade-avoid-deactivation-banner';
const $9336b0b8d90394bf$export$605e10c7fb710fe8 = 'auto-upgrade-avoid-deactivation-flag';
const $9336b0b8d90394bf$export$617971661581b89a = 'addPaymentAvoidDeactivation';
const $9336b0b8d90394bf$export$6b183dcf8256b901 = 'removeUsersAvoidDeactivation';
const $9336b0b8d90394bf$export$88ddc07ee0185a0 = 'autoUpgradeNotATrial';
const $9336b0b8d90394bf$export$4bdf96a244b85ff6 = 'autoUpgradeNotATrial';
const $9336b0b8d90394bf$export$6be2b9eb165d621f = 44;
const $9336b0b8d90394bf$export$51039dd19c9a3762 = {
    confluence: 10,
    'jira-product-discovery': 3,
    'jira-service-management': 3,
    jira: 10
};
const $9336b0b8d90394bf$export$466cbff150b55117 = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'creator',
    ['jira-service-management']: 'agent'
};
const $9336b0b8d90394bf$export$5a01ec5e3068630c = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
const $9336b0b8d90394bf$export$c17ca73287ae9119 = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
module.exports["AUNT_STATSIG_EXPERIMENT_KEY"] = $9336b0b8d90394bf$export$7af15fb4b1ef8bf2;
module.exports["STANDARD_TRIAL_DAYS_TO_DEACTIVATION"] = $9336b0b8d90394bf$export$31c76e063a58551f;
module.exports["AVOID_DEACTIVATION_MODAL_TEST_ID"] = $9336b0b8d90394bf$export$e25ee5e8d56c9434;
module.exports["AVOID_DEACTIVATION_MODAL_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$4c68c8f979e7c34e;
module.exports["AVOID_DEACTIVATION_BANNER_SUBJECT_ID"] = $9336b0b8d90394bf$export$e1dd560345bb2391;
module.exports["AVOID_DEACTIVATION_BANNER_TEST_ID"] = $9336b0b8d90394bf$export$fb4037ac52e8f2af;
module.exports["ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$617971661581b89a;
module.exports["REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$6b183dcf8256b901;
module.exports["TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$88ddc07ee0185a0;
module.exports["TAKE_ACTION_SOURCE_ID"] = $9336b0b8d90394bf$export$4bdf96a244b85ff6;
module.exports["MAX_USERS_ON_FREE_PLAN"] = $9336b0b8d90394bf$export$51039dd19c9a3762;
module.exports["PRODUCT_TO_CHARGE_ELEMENT"] = $9336b0b8d90394bf$export$466cbff150b55117;
module.exports["PRODUCT_TO_ORIGIN"] = $9336b0b8d90394bf$export$5a01ec5e3068630c;
module.exports["ProductKeyToHAMSMap"] = $9336b0b8d90394bf$export$c17ca73287ae9119;

});

parcelRegister("5EhYK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $dhYWb = parcelRequire("dhYWb");

const $b6e61a181e3b095b$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
function $b6e61a181e3b095b$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendAnalyticEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire($b6e61a181e3b095b$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    const createAddPaymentsButtonClickEvent = (source, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: source,
            attributes: attributes
        });
    const createTakeActionClickEvent = (sourceId, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: sourceId,
            attributes: attributes
        });
    const createRemoveUsersButtonClickEvent = (sourceId, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: sourceId,
            attributes: attributes
        });
    const growthErrorHandler = ({ error: error, errorInfo: errorInfo, product: product, source: source })=>sendAnalyticEvent((0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            product: product === 'confluence' ? (0, $gwZbZ.Product).CONFLUENCE : (0, $gwZbZ.Product).JIRA,
            experimentMeta: {
                experimentKey: (0, $dhYWb.AUNT_STATSIG_EXPERIMENT_KEY)
            },
            errorMessage: error.message,
            errorType: (0, $gwZbZ.ErrorType).GENERIC,
            source: source || (0, $dhYWb.AUNT_STATSIG_EXPERIMENT_KEY),
            severity: (0, $gwZbZ.Severity).HIGH,
            additionalAttributes: {
                ...errorInfo
            }
        }));
    return {
        sendAnalyticEvent: sendAnalyticEvent,
        createAddPaymentsButtonClickEvent: createAddPaymentsButtonClickEvent,
        createRemoveUsersButtonClickEvent: createRemoveUsersButtonClickEvent,
        createTakeActionClickEvent: createTakeActionClickEvent,
        growthErrorHandler: growthErrorHandler
    };
}
function $b6e61a181e3b095b$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticEvent: sendAnalyticEvent } = $b6e61a181e3b095b$export$e955abb82869dc84();
    const hasSentScreenEvent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSentScreenEvent.current) return;
        sendAnalyticEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
    }, [
        sendAnalyticEvent,
        name,
        attributes
    ]);
    return null;
}
module.exports["useAnalytics"] = $b6e61a181e3b095b$export$e955abb82869dc84;
module.exports["ScreenEvent"] = $b6e61a181e3b095b$export$b901544a79a3bbad;

});

parcelRegister("b0bCf", function(module, exports) {

var $dhYWb = parcelRequire("dhYWb");

const $e5eb9cf773a94bba$export$68b898ecc084962 = (product)=>{
    return {
        chargeElementSingular: (0, $dhYWb.PRODUCT_TO_CHARGE_ELEMENT)[product],
        chargeElementPlural: (0, $dhYWb.PRODUCT_TO_CHARGE_ELEMENT)[product] + 's'
    };
};
const $e5eb9cf773a94bba$export$291d012eb0744b34 = (product)=>{
    return (0, $dhYWb.ProductKeyToHAMSMap)[product];
};
const $e5eb9cf773a94bba$export$8e8e465e66e8e161 = (product)=>{
    switch(product){
        case 'jira':
            return 'Jira';
        case 'jira-service-management':
            return 'Jira Service Management';
        case 'jira-product-discovery':
            return 'Jira Product Discovery';
        case 'confluence':
            return 'Confluence';
        default:
            return '';
    }
};
module.exports["getChargeElementTypeByProduct"] = $e5eb9cf773a94bba$export$68b898ecc084962;
module.exports["getHamsKey"] = $e5eb9cf773a94bba$export$291d012eb0744b34;
module.exports["getProductNameFromProductKey"] = $e5eb9cf773a94bba$export$8e8e465e66e8e161;

});

parcelRegister("fAD9L", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $TSbNa = parcelRequire("TSbNa");

const $71b8fe84901d80f2$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $42omo.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $42omo.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $71b8fe84901d80f2$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $42omo.useRef)(1);
    const [modals, setModals] = (0, $42omo.useState)([]);
    const modalContext = (0, $42omo.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $TSbNa.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $l998X.jsx)($71b8fe84901d80f2$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}
module.exports["ModalContextProvider"] = $71b8fe84901d80f2$export$7c9538f5f3c365e9;

});

parcelRegister("TSbNa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $645b684711965e78$export$ab57792b9b6974a6 = (0, $42omo.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});
module.exports["ModalContext"] = $645b684711965e78$export$ab57792b9b6974a6;

});

parcelRegister("7wGk4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $iP9n7 = parcelRequire("iP9n7");


var $cQDYl = parcelRequire("cQDYl");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $eyWa4 = parcelRequire("eyWa4");


var $4M6GB = parcelRequire("4M6GB");


var $TSbNa = parcelRequire("TSbNa");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");

const $abc57e0f1f470075$var$emptyEntryPointParams = {};
const $abc57e0f1f470075$var$emptyEntryPointProps = {};
function $abc57e0f1f470075$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = false }) {
    (0, $fBMbo.di)((0, $irOoi.loadEntryPoint));
    const { openModal: openModal } = (0, $42omo.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const metricName = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $abc57e0f1f470075$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        children: title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $l998X.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $abc57e0f1f470075$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
module.exports["ModalTrigger"] = $abc57e0f1f470075$export$fb10b32cfe19f1e;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("7wYo8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $68a341f15f9dda7b$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $68a341f15f9dda7b$var$TIME_TO_INTENT = 200;
function $68a341f15f9dda7b$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { clickListener: clickListener, mouseDownListener: mouseDownListener, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $68a341f15f9dda7b$var$PRELOAD_MAX_AGE);
            }, $68a341f15f9dda7b$var$TIME_TO_INTENT);
        };
        return {
            cancelPreload: cancelPreload,
            clickListener: clickListener,
            mouseDownListener: mouseDownListener,
            preloadReference: preloadReference
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $68a341f15f9dda7b$export$1ff47f24e06a5d2d;

});

parcelRegister("bJq0d", function(module, exports) {
var $cdac08834664f9ea$export$23e8f571dd61cd8c = /*#__PURE__*/ function(MPU_QUERY) {
    MPU_QUERY["HAMS_PRODUCT_KEY"] = "confluence.ondemand";
    MPU_QUERY["OFFERING_KEY"] = "2eda1119-fab4-4699-ab37-ff8f12052cde";
    return MPU_QUERY;
}({});
module.exports["MPU_QUERY"] = $cdac08834664f9ea$export$23e8f571dd61cd8c;

});


//# sourceMappingURL=TrialFlags.0aa03781.js.map
